import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CardContainer from "./CardContainer";
import ClickableText from "../Texts/ClickableText";
import SectionHeading from "../Chip/SectionHeading";
import { COPY_VALUES_IN_OTHER_ADGROUPS } from "../../i18n/keysTranslations";
import { useTranslationApp } from "../../lib/i18next";
import { useFormContext } from "react-hook-form";
import { getReactHookFormNestedError } from "../../utils/errors";
import { aiGeneratedSectionFromFieldPath } from "../../utils/aiGenerated";

/**
 * Reusable CardContainer component with optional copy functionality and Grid wrapper
 */
const CardContainerWithCopy = ({
  title,
  disabled = false,
  hasCopyValue = false,
  onCopyCallback,
  id,
  copyText = COPY_VALUES_IN_OTHER_ADGROUPS,
  aiGeneratedSection,
  children,
}) => {
  const { t } = useTranslationApp();
  const {
    formState: { errors },
  } = useFormContext();

  const error = getReactHookFormNestedError(errors, id);
  const resolvedSection =
    aiGeneratedSection?.basePath && aiGeneratedSection?.section
      ? aiGeneratedSection
      : aiGeneratedSectionFromFieldPath(id);

  const titleContent = (
    <Box sx={{ display: "flex", flexDirection: "column" }} id={id}>
      <SectionHeading
        basePath={resolvedSection?.basePath}
        section={resolvedSection?.section}
      >
        <Typography variant="h6" sx={{ fontWeight: 600 }}>
          {title}
        </Typography>
      </SectionHeading>
      {error?.message && (
        <Typography variant="caption" color="error">
          {error?.message}
        </Typography>
      )}
      {hasCopyValue && (
        <ClickableText disabled={disabled} onClick={onCopyCallback}>
          {t(copyText)}
        </ClickableText>
      )}
    </Box>
  );

  const cardContent = (
    <CardContainer title={titleContent} dynamicHeight={true}>
      {children}
    </CardContainer>
  );

  return cardContent;
};

export default CardContainerWithCopy;
